import React from 'react';

/**
 * Skeleton da página de detalhes do imóvel — ocupa altura suficiente para o footer
 * ficar no rodapé durante o carregamento (navegação interna da listagem).
 */
export default function PropertyDetailsSkeleton() {
  return (
    <div
      className="min-h-screen bg-gray-50"
      style={{ fontFamily: 'Montserrat, sans-serif' }}
      aria-busy="true"
      aria-label="Carregando imóvel"
    >
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-8 flex flex-wrap items-center gap-2">
          <div className="h-4 w-14 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-3 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-3 animate-pulse rounded bg-gray-200" />
          <div className="h-4 w-40 animate-pulse rounded bg-gray-200" />
        </div>

        <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex-1 space-y-3">
            <div className="h-9 w-full max-w-2xl animate-pulse rounded-lg bg-gray-200" />
            <div className="h-5 w-48 animate-pulse rounded bg-gray-200" />
          </div>
          <div className="hidden h-10 w-36 animate-pulse rounded-lg bg-gray-200 sm:block" />
        </div>

        <div className="mb-8 grid grid-cols-1 gap-3 md:grid-cols-4 md:grid-rows-2">
          <div className="aspect-[4/3] animate-pulse rounded-xl bg-gray-200 md:col-span-2 md:row-span-2 md:aspect-auto md:min-h-[420px]" />
          <div className="aspect-[4/3] animate-pulse rounded-xl bg-gray-200 md:aspect-auto md:min-h-[200px]" />
          <div className="aspect-[4/3] animate-pulse rounded-xl bg-gray-200 md:aspect-auto md:min-h-[200px]" />
          <div className="aspect-[4/3] animate-pulse rounded-xl bg-gray-200 md:aspect-auto md:min-h-[200px]" />
          <div className="aspect-[4/3] animate-pulse rounded-xl bg-gray-200 md:aspect-auto md:min-h-[200px]" />
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="space-y-4 lg:col-span-2">
            <div className="h-6 w-40 animate-pulse rounded bg-gray-200" />
            <div className="space-y-2">
              <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
              <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
              <div className="h-4 w-5/6 animate-pulse rounded bg-gray-200" />
              <div className="h-4 w-4/6 animate-pulse rounded bg-gray-200" />
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {Array.from({ length: 4 }, (_, i) => (
                <div key={i} className="h-20 animate-pulse rounded-lg bg-gray-200" />
              ))}
            </div>
          </div>
          <div className="space-y-4">
            <div className="h-48 animate-pulse rounded-xl bg-gray-200" />
            <div className="h-12 animate-pulse rounded-lg bg-gray-200" />
            <div className="h-12 animate-pulse rounded-lg bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  );
}
